import type {ReactNode} from "react";
import React from "react";
import {observer} from "mobx-react-lite";
import type {AlertColor} from "@mui/material/Alert";
import {Alert, Button} from "@mui/material";
import moment from "moment";
import {useStores} from "~/stores";

export const DefaultAlert: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores();
    const pageController = categorizationReviewStore.reviewPageController;
    const approvalController = pageController.reviewPageApprovalController;
    const taxonomyStatus = categorizationReviewStore.statusDelegate.taxonomyStatus;

    let isWarning = false;
    let message: string | ReactNode;
    let action: ReactNode | undefined = undefined;

    if (pageController.paginationStateInvalid || pageController.paginationStateInvalidSupplierId) {
        message = 'The page is not valid anymore! This happens because you (or another user) has reviews after your last load.';
        action = <Button color="inherit" size="small" onClick={() => {
            if (pageController.paginationStateInvalid)
                pageController.reviewPageTableController.muixCustomizedPaginationOnPageChange(0);
            else {
                pageController.reviewPageTableController.resetGroupPerPage(pageController.paginationStateInvalidSupplierId!);
                pageController.reviewPageTableController.refreshGroupedRow(pageController.paginationStateInvalidSupplierId!);
            }
        }}>Go to 1'st page</Button>
    } else if (categorizationReviewStore.viewOnly) {
        // Note: Ensure this alert is aligned with `CategorizationReviewStore.canEditReviews`
        message = 'Your account is view-only, you cannot edit this page'
    } else if (approvalController.isSendForApprovalWaiting) {
        // This message is added here as well to ensure that we clearly state when the review screen is not usable
        // e.g. when canEditReviews === false
        isWarning = true;
        message = 'Collecting your data for the approval process, please wait';
    } else {
        if (!taxonomyStatus) return <></>;
        const taxonomy = taxonomyStatus.taxonomy;
        const approval = taxonomyStatus.approval;

        if (!taxonomy) {
            isWarning = true;
            message = 'There is no taxonomy available for review';
        } else {
            const date = moment(taxonomy.created_at);
            if (approval) {
                isWarning = true;
                const approvalDate = moment(approval.created_timestamp);
                message = `You are reviewing with taxonomy "${taxonomy.name}" from ${date.format('L')}, the approval is pending since ${approvalDate.format('L')}`;
            } else if (taxonomy.current_operation_number > 1) {
                isWarning = true;
                message = `You are reviewing with taxonomy "${taxonomy.name}" from ${date.format('L')}, changes to the taxonomy are not send for approval`;
            } else {
                isWarning = false;
                message = `You are reviewing the categorization based on taxonomy "${taxonomy.name}" from ${date.format('L')}`;
            }
        }
    }

    const severity: AlertColor = isWarning ? 'warning' : 'info';
    const style: React.CSSProperties = isWarning ? {} : {background: '#0262F21A'};
    return <Alert severity={severity} action={action} style={style}>{message}</Alert>
})
